import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";
import { BulkActionsVariant } from "components/BulkActions/types";
import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";

import {
  WorkerPoolQueuedRunsBulkActionsSelectedAction,
  WorkerPoolQueuedRunsBulkActionsAnalyticsPayload,
} from "./types";

type WorkerPoolQueuedRunsBulkActionsConfirmActionFormProps = {
  action: WorkerPoolQueuedRunsBulkActionsSelectedAction;
  variant: BulkActionsVariant;
  onConfirm: (analyticsPayload: WorkerPoolQueuedRunsBulkActionsAnalyticsPayload) => void;
  onCancel: () => void;
};

const WorkerPoolQueuedRunsBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
}: WorkerPoolQueuedRunsBulkActionsConfirmActionFormProps) => {
  return (
    <BulkActionsConfirmActionStep>
      <BulkActionsConfirmActionStepInlineConfirmation
        variant={variant}
        actionLabel={action.title}
        onConfirm={() =>
          onConfirm({
            view: variant,
          })
        }
        onCancel={onCancel}
      />
    </BulkActionsConfirmActionStep>
  );
};

export default WorkerPoolQueuedRunsBulkActionsConfirmActionForm;
